<section class="p-6 space-y-6">
  <!-- Header Section -->
  <div class="flex justify-between items-center">
    <h1 class="text-3xl font-bold text-gray-900">Associates</h1>
    <div class="flex items-center gap-3">
      <label class="input input-bordered input-sm flex items-center gap-2 w-64">
        <i class="ri-search-line text-gray-400"></i>
        <input type="text" class="grow" placeholder="Search associates..." [(ngModel)]="searchTerm"
          (input)="onSearch($event)" />
      </label>
      <a routerLink="create-associate" class="btn btn-primary btn-sm flex items-center gap-2"
        routerLinkActive="btn-active">
        <i class="ri-add-line"></i>
        Create New Associate
      </a>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="bg-white rounded-lg shadow-sm border p-4">
    <div class="flex flex-wrap gap-3">
      <div class="form-control w-42">
        <label class="label">
          <span class="label-text text-sm font-semibold">Location</span>
        </label>
        <label class="input input-bordered input-sm flex items-center gap-2">
          <i class="ri-map-pin-line text-gray-400"></i>
          <input type="text" class="grow" placeholder="Search location..." [(ngModel)]="locationFilter"
            (input)="onFilterChange()" />
        </label>
      </div>

      <div class="form-control w-44">
        <label class="label">
          <span class="label-text text-sm font-semibold">Student Range</span>
        </label>
        <select class="select select-sm select-bordered" [(ngModel)]="studentRangeFilter" (change)="onFilterChange()">
          <option [ngValue]="'All'">All</option>
          <option [ngValue]="'upto300'">upto 300</option>
          <option [ngValue]="'300-700'">300-700</option>
          <option [ngValue]="'700-1000'">700-1000</option>
          <option [ngValue]="'1000-1300'">1000-1300</option>
          <option [ngValue]="'custom'">Custom</option>
        </select>

        <div *ngIf="studentRangeFilter === 'custom'" class="mt-2 flex gap-2">
          <input
            type="number"
            class="input input-bordered input-sm w-28"
            placeholder="Min"
            [(ngModel)]="customStudentMinInput"
            (input)="onCustomStudentRangeChange()"
          />
          <input
            type="number"
            class="input input-bordered input-sm w-28"
            placeholder="Max"
            [(ngModel)]="customStudentMaxInput"
            (input)="onCustomStudentRangeChange()"
          />
        </div>
      </div>

      <div class="form-control w-40">
        <label class="label">
          <span class="label-text text-sm font-semibold">Category</span>
        </label>
        <select class="select select-sm select-bordered" [(ngModel)]="categoryFilter" (change)="onFilterChange()">

          <option *ngFor="let cat of categories" [value]="cat">{{cat}}</option>
        </select>
      </div>

      <div class="form-control w-44">
        <label class="label">
          <span class="label-text text-sm font-semibold">White Labelled</span>
        </label>
        <select class="select select-sm select-bordered" [(ngModel)]="whiteLabelledFilter" (change)="onFilterChange()">
          <option value="">All</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Table Section -->
  <div class="bg-white rounded-lg shadow-sm border overflow-hidden">
    <div class="overflow-x-auto">
      <table class="table table-auto w-full">
        <thead class="sticky top-0 bg-gray-50">
          <tr>
            <th class="w-12">
              <input type="checkbox" class="checkbox checkbox-sm" (change)="toggleAll($event)" />
            </th>
            <th>College Name</th>
            <th>Location</th>

            <th>Category</th>
            <th>White Labelled</th>
            <th class="w-48">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (associate of filteredAssociates; track associate.id) {
          <tr class="hover:bg-gray-50 transition-colors border-b border-gray-100">
            <th>
              <input type="checkbox" class="checkbox checkbox-sm" [checked]="isSelected(associate)"
                (change)="onCheckboxChange(associate, $event)" />
            </th>
            <td class="font-semibold">{{associate.collegeName}}</td>
            <td>{{associate.location}}</td>

            <td>{{associate.category}}</td>
            <td>
              <span class="badge  text-xs" *ngIf="associate.whiteLabelled">Yes</span>
              <span class="badge  text-xs" *ngIf="!associate.whiteLabelled">No</span>
            </td>
            <td>
              <div class="flex gap-1">
                <button class="btn btn-sm btn-ghost" data-tip="Edit" (click)="onEditAssociate(associate.id)">
                  <i class="ri-pencil-line"></i>
                </button>
                <button class="btn btn-sm btn-ghost" data-tip="Analytics" (click)="onAnalytics(associate.id)">
                  <i class="ri-bar-chart-2-line"></i>
                </button>
                <button class="btn btn-sm btn-ghost" data-tip="Delete" (click)="onDeleteAssociate(associate.id)">
                  <i class="ri-delete-bin-line"></i>
                </button>

              </div>
            </td>
          </tr>
          } @empty {
          <tr>
            <td colspan="7" class="text-center py-8 text-gray-500">No associates found matching the filters.</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- Summary -->
  @if (selectedAssociates.length > 0) {
  <div class="text-sm text-gray-600">
    {{selectedAssociates.length}} associates selected
  </div>
  }
</section>